import has from '@dojo/framework/core/has';
import { LPKid, LPView, View } from '../../shared/init/interfaces';

const breadcrumbs: LPKid[] = has('use-micro-view')
	? [
			{
				widget: 'Widget',
				name: 'quiz-breadcrumbs',
				realwidget: 'MicroBreadcrumbs'
			}
		]
	: [];

export const viewFromLpl = (lpl: LPView): View => {
	const { widget } = lpl;
	const params: Partial<View> = { ...lpl };
	delete params['widget'];
	return { widget, params };
};

export const assessment = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'assessment-view',
		kids: [
			{
				widget: 'Group',
				name: 'assessment-body',
				classes: ['assessment-body'],
				kids: [
					...breadcrumbs,
					{
						widget: 'Widget',
						name: 'assessment-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const practice = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'practice-view',
		kids: [
			{
				widget: 'Group',
				name: 'practice-body',
				classes: ['practice-body'],
				kids: [
					...breadcrumbs,
					{
						widget: 'Widget',
						name: 'practice-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const bonus = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'bonusquiz-view',
		kids: [
			{
				widget: 'Group',
				name: 'bonusquiz-body',
				classes: ['bonusquiz-body'],
				kids: [
					...breadcrumbs,
					{
						widget: 'Widget',
						name: 'bonus-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const posttest = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'posttest-view',
		kids: [
			{
				widget: 'Group',
				name: 'posttest-body',
				classes: ['posttest-body'],
				kids: [
					...breadcrumbs,
					{
						widget: 'Widget',
						name: 'posttest-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const quiz = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'quiz-view',
		kids: [
			{
				widget: 'Group',
				name: 'quiz-body',
				classes: ['quiz-body'],
				kids: [
					...breadcrumbs,
					{
						widget: 'Widget',
						name: 'general-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};
